import { render, staticRenderFns } from "./ClientPdf.vue?vue&type=template&id=543e457f&"
import script from "./ClientPdf.vue?vue&type=script&lang=js&"
export * from "./ClientPdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports